<ng-container *ngIf="!!get">
    <tt-card class="flex-1" ttClass="height-full flex-column">
        <tt-input ttLabel="filtervalue" [(ttModel)]="get.filtervalue" ttShowClearButton></tt-input>
        <tt-list class="flex-1" ttHeightFull ttRadioSelection (ttRadioSelectionChanged)="onItemClicked($event)" [ttFilter]="get.filtervalue" [ttData]="models" ttGoto="false"></tt-list>
    </tt-card>

    <tt-card *ngIf="get.show_setting === '1'">
        <tt-button-settings></tt-button-settings>
    </tt-card>
</ng-container>
